"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelCaseToKebabCase = void 0;
const camelCaseToKebabCase = value => value.replace(/([\da-z])([A-Z])/g, '$1-$2').toLowerCase();
exports.camelCaseToKebabCase = camelCaseToKebabCase;
//# sourceMappingURL=stringUtils.js.map